/* raw layout hash: _default-web-layout-1mnzqsb:84f2ecc933155f2e69afae3dd4704efa6300707163112221b04f72fa46c6efcf */
import DefaultWebShell from './components/DefaultWebShell.jsx';

/**
 * Layout `_default-web-layout-1mnzqsb`
 * Source shell: RawHTMLDesign/layouts/_default-web-layout-1mnzqsb.html
 *
 * A distinct layout in the design catalogue whose chrome matches
 * `_default-web-layout` — the raw shells differ only by whitespace in `<head>`
 * (an extra blank line after the font-awesome `<link>`). Kept as its own
 * component so the design's layout name maps 1:1 to a component; the shared
 * chrome comes from DefaultWebShell rather than being copy-pasted.
 *
 * Pages using this layout: Brand Elements & Presets, Asset Vault & Projects
 * (both authenticated → signed-in details + log out in the navbar).
 */
export default function DefaultWebLayout1mnzqsb({ children }) {
  return <DefaultWebShell>{children}</DefaultWebShell>;
}
